import { render, staticRenderFns } from "./productDetails.vue?vue&type=template&id=1baf776e&scoped=true"
import script from "./productDetails.vue?vue&type=script&lang=js"
export * from "./productDetails.vue?vue&type=script&lang=js"
import style0 from "./productDetails.vue?vue&type=style&index=0&id=1baf776e&prod&scoped=true&lang=less"
import style1 from "./productDetails.vue?vue&type=style&index=1&id=1baf776e&prod&lang=less&scoped=true"
import style2 from "./productDetails.vue?vue&type=style&index=2&id=1baf776e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baf776e",
  null
  
)

export default component.exports